module.exports = __webpack_public_path__ + "static/img/2415(2).0eb6e0d0.png";